import React from 'react'

const Footer = () => {
    return (
        <>
            <footer className="footer">
                <p className="copyright">
                    &copy; 2021 Amit Yadav
                </p>
                
            </footer>
        </>
    )
}

export default Footer
